{
  "en": {
    "js": {
      "components": {
        "action_suggestion_modal": {
          "suggestion": "Action suggestion"
        },
        "actions_dropdown": {
          "more_options": "More options",
          "open_menu": "Open menu"
        },
        "analysis_page": {
          "benchmark_base_tooltip": "An average property in Planima has %{benchmark} per m² in maintenance debt.",
          "building": "building",
          "by_action_type": "Expense type and year",
          "by_budget_excluding_vat": "Budgeted per year (excl. VAT)",
          "by_budget_including_vat": "Budgeted per year (incl. VAT)",
          "by_category": "Category and year",
          "by_savings": "Energy savings (kr) and year",
          "category": "category",
          "cost_kpi_title": "Expense",
          "cost_kpi_tooltip": "Expense for all selected actions",
          "facility": "property",
          "graph_header": "Expenses per year",
          "graph_header_savings": "Savings per year",
          "higher_value": "This value is %{percentage}% higher.",
          "investment": "Investment",
          "lower_value": "This value is %{percentage}% lower.",
          "maintenance": "Maintenance",
          "maintenance_debt": "Maintenance debt",
          "maintenance_debt_tooltip": "Expenses for maintenance actions that are deferred, urgent, and not completed actions earlier than this year",
          "misc": "Miscellaneous",
          "multiple_facilities": "properties'",
          "one_facility": "property's",
          "per_area": "per m²",
          "per_year": "per year",
          "per_year_and_area": "per year and m²",
          "previous_savings_info": "Can also show savings from actions that have been carried out or planned earlier, but only if their savings interval overlaps the filtered period.",
          "status": "status",
          "tooltip_info": "%{base}. For calculations based on m², the total area of %{facility_string} is used.",
          "total_electricity_savings": "Electricity",
          "total_energy_savings": "Energy savings in SEK",
          "total_heating_savings": "Heating"
        },
        "analysis_pie_chart": {
          "title": "Expense per %{name}"
        },
        "attachment_dropzone": {
          "allowed_extensions_text": "Allowed file types: %{extensions}",
          "dropzone_text": "Drag files here or click to upload (max %{max} MB)",
          "error": "An error occurred during upload.",
          "heic_converted_notice": "HEIC images have been converted to JPEG so they can be displayed in the browser",
          "invalid_file_notice": "You tried to upload an invalid file.",
          "rejected_file_notice": "Files must not be larger than %{max_size} MB",
          "success_message": "%{successful} of %{total} files uploaded.",
          "success_notice": "Upload complete!",
          "too_many_files_notice": "You can upload a maximum of %{max_files} files at the same time.",
          "upload_count": "%{completed} of %{total} files uploaded...",
          "uploading": "Uploading..."
        },
        "attachment_list": {
          "confirm_delete": "Are you sure you want to delete the file?",
          "file_size": "File size",
          "name": "Name",
          "user_email": "Uploaded by"
        },
        "attachment_view": {
          "removed_file": "The file has been deleted."
        },
        "building_graphs": {
          "by_action_type": "Expense type and year",
          "by_energy_savings_in_kr": "Energy savings (kr) and year",
          "by_energy_savings_in_kwh": "Energy savings (kWh) and year",
          "previous_savings_info": "Shows annual savings from previous measures whose energy-saving effects extend into the selected time period."
        },
        "chart_selector": {
          "choose_graph": "Choose chart:"
        },
        "climate_risks_bar_chart": {
          "empty_graph": "The chart contains no data",
          "label": {
            "high": "High risk",
            "medium": "Medium risk"
          },
          "tooltip": {
            "facilities": {
              "one": "1 property",
              "other": "%{count} properties"
            },
            "total_facilities": {
              "one": "Total: 1 property",
              "other": "Total: %{count} properties"
            }
          }
        },
        "combobox": {
          "create_new": "Add \"%{value}\"",
          "deselect_all": "Deselect all",
          "deselect_visible": "Deselect visible",
          "hidden_selected": "%{count} more selected",
          "new_items_group": "New items",
          "no_results": "No results found",
          "remove": "Remove",
          "select_all": "Select all",
          "select_all_summary": "%{selected} of %{total} selected",
          "select_visible": "Select visible"
        },
        "complete_action_modal": {
          "budget_label": "Budget",
          "budget_moved_notice": "If you complete the action, it moves to %{year} and is removed from the budget %{budget_name}",
          "budget_no_budgets_for_year": "There are no budgets for the selected year",
          "budget_placeholder": "Choose budget",
          "comment": "Comment",
          "comment_info": "For example, who performed the action, which products/brands were used, or other information not shown in the action.",
          "complete_action": "Complete action",
          "completed_year": "Completed year",
          "current_year": "Current year:",
          "excluding_vat": "excl. VAT.",
          "final_cost": "Actual price (excl. VAT)",
          "info": "Enter information about the completed action. This can be very valuable for future planning, so try to include as much as possible!",
          "planned_cost": "Planned price:",
          "planned_year": "Planned year:"
        },
        "deposition_analysis": {
          "balance_current": "Fund balance at current allocation",
          "balance_recommended": "Fund balance at recommended allocation",
          "current_deposition": "Current allocation per year and m² (residential area)",
          "info": "The allocation analysis shows <strong>your entire maintenance plan</strong> and <strong>excludes investment actions</strong>. Any filters set do not affect the analysis.",
          "not_defined": "Define residential area and allocation",
          "recommended_deposition": "Recommended allocation per year and m² (residential area)",
          "title": "Allocation analysis"
        },
        "deposition_settings": {
          "balance": "Balance",
          "current_balance": "Maintenance fund balance at the beginning of year %{year}",
          "current_deposition": "Current allocation",
          "current_yearly_deposition": "Current allocation per year",
          "info": "This value is set manually, usually by the provider of the maintenance plan. If you do not have a provider, you can either set your own allocation goal or disregard this field.",
          "recommended_deposition": "Recommended allocation",
          "recommended_yearly_deposition": "Recommended allocation per year",
          "update": "Update"
        },
        "dialog": {
          "close": "Close"
        },
        "drawer": {
          "close": "Close",
          "unsaved_changes_confirm": "Your changes haven't been saved. If you close now, you'll lose what you changed."
        },
        "error_boundary": {
          "contact_us": "Please try reloading the page or contact our support if the problem persists.",
          "message": "The content could not be displayed due to an unexpected error.",
          "reload": "Reload page",
          "title": "Something went wrong"
        },
        "facilities_page_analysis": {
          "by_action_type": "Expense type and year",
          "by_facilities": "Property and year",
          "by_savings": "Energy savings (kr) and year",
          "by_tags": "Tag and year",
          "missing": "Missing",
          "previous_savings_info": "Can also show savings from actions that have been carried out or planned earlier, but only if their savings interval overlaps the filtered period."
        },
        "facilities_sustainability_pie_chart": {
          "building": "building",
          "buildings": "buildings"
        },
        "facility_part_list": {
          "amount": "Amount",
          "name": "Name",
          "unit": "Unit"
        },
        "facility_part_modal": {
          "close": "Back",
          "title": "Bill of quantities"
        },
        "list_items_per_page_selection": {
          "rows": "Number of rows"
        },
        "list_settings": {
          "search": "Search..."
        },
        "list_table": {
          "filter_label": "Search here...",
          "page_info": "Showing %{from} to %{to} of %{total} rows",
          "page_size_label": "Number of rows"
        },
        "magic_link_generator": {
          "confirm": "Are you sure? There is an old link that will become invalid.",
          "copy_to_clipboard": "Copy to clipboard",
          "error": "Something went wrong. Try reloading the page.",
          "resubmit": "Regenerate",
          "submit": "Generate"
        },
        "maintenance_plan_select": {
          "facility": "Property",
          "facility_tag": "Property tag",
          "more": "more",
          "no_results": "No results",
          "organization": "Organization",
          "prompt": "Search by property, property tag, or organization..."
        },
        "modal": {
          "close": "Close"
        },
        "pagination_controls": {
          "next": "Next",
          "previous": "Previous"
        },
        "pagination_info": {
          "info": "Showing %{from} to %{to} of %{total} rows"
        },
        "panel": {
          "hide": "Hide",
          "show": "Show"
        },
        "puts": {
          "dropdown_menu": {
            "open_menu": "Open menu"
          },
          "pagination": {
            "next_page": "Next page",
            "page": "Page %{page}",
            "previous_page": "Previous page"
          },
          "spinner": {
            "loading": "Loading…"
          },
          "tabs": {
            "more_tabs": "More tabs"
          }
        },
        "rails_filter_multi_select": {
          "all_selected": "All selected",
          "search": "Search",
          "select_all": "Select all",
          "select_some": "Select %{item}"
        },
        "status_picker": {
          "unchanged": "Unchanged",
          "unknown": "Unknown status"
        },
        "suggestion_list": {
          "built_in_suggestion": "Planima Prices™",
          "contact_us": "Contact our support for more information!",
          "emission": "Emissions",
          "energy_saving": "Energy saving",
          "feedback": "submit a request through our form!",
          "name": "Name",
          "repeated": "Interval",
          "show_more": "Want to see all content or add your own actions?",
          "suggestion_info_1": "The list includes suggestions from",
          "suggestion_info_2": ", a smart price list for maintenance. If you think something is missing in Planima Prices™, please",
          "suggestion_info_3": "For more advanced needs, you can also create and edit action suggestions yourself -",
          "suggestions_info_title": "Missing something?",
          "trial_account_info_1": "You are viewing a selection of actions from",
          "trial_account_info_2": ", our comprehensive price database for maintenance. The full version contains over 1300 actions with associated costs, climate impact (CO₂), and recommended intervals.",
          "trial_account_info_title": "Example list from Planima Prices™",
          "unit": "Unit",
          "unit_price": "Unit price"
        },
        "sustainability_page": {
          "by_energy_savings": "Energy savings (kWh) and year",
          "by_yearly_emissions": "Emissions and year",
          "emission_calculation_info": "Reported emissions for actions are within <strong>Scope 3</strong> (embodied emissions). Calculation methodology follows the GHG protocol, specifically the <strong>Sector Supplement for Measuring and Accounting for Embodied Emissions in the Built Environment</strong>. Emissions data is retrieved from industry databases (e.g. Boverket's Climate Database), and EPDs"
        },
        "time_bar_chart": {
          "title": "Maintenance debt"
        },
        "toast": {
          "close": "Close"
        }
      },
      "config": {
        "tom_select": {
          "add_item": "Add",
          "no_results": "No results found"
        }
      },
      "confirm_delete_modal": {
        "case_app_customer": "it will be archived along with its organizations, facilities and plans. Its users will be removed and can only be partly restored.",
        "case_building": "the building, its energy class and its associated components will be permanently deleted.",
        "case_category": "it will be removed and actions linked to the category will become uncategorized but remain. This also applies to actions in inactive maintenance plans.",
        "case_component_with_actions": "it will be permanently deleted. For the %{count} linked actions, only the link will be removed, the actions will remain.",
        "case_component_without_actions": "it will be permanently deleted.",
        "case_facility": "it and its plans will be permanently deleted.",
        "case_mass_edit": "they and any of their possible repetitions will be permanently deleted.",
        "case_organization": "it and its properties and plans will be permanently deleted.",
        "default": "it will be permanently deleted."
      },
      "data_tables": {
        "aria": {
          "sort_ascending": ": activate to sort the column in ascending order",
          "sort_descending": ": activate to sort the column in descending order"
        },
        "empty_table": "The table contains no data",
        "info": "Showing _START_ to _END_ of total _TOTAL_ rows",
        "info_empty": "Showing 0 to 0 of total 0 rows",
        "info_filtered": "(filtered from a total of _MAX_ rows)",
        "length_menu": "Show _MENU_ rows",
        "loading_records": "Loading...",
        "paginate": {
          "first": "First",
          "last": "Last",
          "next": "Next",
          "previous": "Previous"
        },
        "processing": "Processing...",
        "search": "Search:",
        "zero_records": "No matching results found"
      },
      "form": {
        "buttons": {
          "cancel": "Cancel",
          "save": "Save"
        },
        "labels": {
          "address": "Address",
          "app_customer": "Customer",
          "name": "Name",
          "organization": "Organization",
          "region": "City",
          "year_of_construction": "Year of construction",
          "zip_code": "Zip code"
        }
      },
      "helpers": {
        "budget": {
          "amount_label": {
            "excluding_vat": "Budget cap (excl. VAT)",
            "including_vat": "Budget cap (incl. VAT)"
          },
          "amount_tooltip": "Whether budgets include VAT is set at the account level",
          "name_label": "Budget name",
          "name_placeholder": "E.g. Maintenance budget"
        },
        "currency": "SEK",
        "delete": "Delete",
        "download": "Download",
        "emission_unit": "kg CO₂e",
        "energy_unit": "kWh",
        "maintenance_plan_action": {
          "build_diff": {
            "indexation": "update indexation base year to current year",
            "remove_field_html": "remove <strong>%{translated_key}</strong>",
            "update_field_html": "update <strong>%{translated_key} to %{value}</strong>"
          },
          "changes": "If you click the button below, we will %{changes} and save the action.",
          "diff_from_suggestion": "This action does not have the same information as the action suggestion it follows. Do you want to update this action to match the action suggestion \"%{suggestion_name}\"?",
          "fields": {
            "carbon_dioxide_equivalent": "emissions per unit",
            "is_energy_saving": "energy saving",
            "repeated": "interval",
            "unit": "unit",
            "unit_price": "unit price"
          },
          "sync_action_submit": "Update action"
        },
        "no": "No",
        "planima_price": "Planima price",
        "removed_user": "Removed user",
        "year": "Year",
        "yes": "Yes"
      },
      "lib": {
        "chart_helpers": {
          "energy_savings": "Energy savings",
          "investment": "Investment",
          "maintenance": "Maintenance",
          "misc": "Uncategorized",
          "total": "Total"
        },
        "maintenance_plan_action": {
          "status_options": {
            "completed": "Completed",
            "decided": "Decided",
            "deferred": "Deferred",
            "draft": "Draft",
            "in_progress": "In progress",
            "inactive": "Inactive",
            "planned": "Planned",
            "prioritized": "Urgent"
          }
        }
      },
      "pages": {
        "account": {
          "budget_settings": {
            "form": {
              "budget_change_notice": "There is at least one budget on the account. The amounts entered in the budgets will not change.",
              "excl_vat": "Excl. VAT",
              "incl_vat": "Incl. VAT",
              "info": "Here you choose whether budgets are entered including or excluding VAT. The setting applies to all budgets on the account, and never changes amounts that have already been entered.",
              "vat_basis_label": "VAT basis"
            }
          }
        },
        "facilities": {
          "buildings": {
            "form": {
              "building_definition": "A building is a structure on the legal property and is used to group actions in the maintenance plan."
            }
          },
          "moves": {
            "form": {
              "edit_link": "Edit facility",
              "info": "The property is moved to a different organization, which may change which users have access to it.",
              "other_errors": "The facility could not be moved because of an error on another field. Edit the facility to see and fix it.",
              "placeholder": "Select organization",
              "submit": "Move"
            }
          }
        },
        "organizations": {
          "form": {
            "app_customer": {
              "info": "NOTE! If the organization's customer affiliation is changed, the previous customer's users will lose access to the organization and its properties.",
              "label": "Customer",
              "placeholder": "Choose customer account"
            },
            "logo": {
              "delete": "Remove image",
              "delete_confirm": "Are you sure?",
              "help_text": "Save with your standard logo, or choose a custom image above.",
              "label": "Logo"
            },
            "name": {
              "help_text": "Can be, for example, company, customer, or manager name depending on the division.",
              "label": "Name"
            }
          },
          "moves": {
            "form": {
              "edit_link": "Edit organization",
              "info": "The organization is moved to the selected customer account. This may change which users have access to it. Connections between the actions and their projects, budgets, and custom action suggestions are permanently removed and can't be restored.",
              "other_errors": "The organization could not be moved because of an error on another field. Edit the organization to see and fix it.",
              "placeholder": "Choose customer account",
              "submit": "Move"
            }
          }
        }
      },
      "stimulus_controllers": {
        "action_types_fallback": {
          "loading_error": "Unfortunately, the suggestions couldn’t be loaded due to an issue with an external service.",
          "try_again": "Please try reloading the page or come back a little later."
        },
        "autocomplete": {
          "error": "Something went wrong! Reload the page and try again."
        },
        "character_counter": {
          "approaching_limit": "Approaching the character limit"
        },
        "component_selection": {
          "remove_component": "Delete"
        },
        "google_maps": {
          "highest_risks": "Highest risk(s)"
        },
        "tag_list": {
          "diverging": "different"
        },
        "turbo_confirm": {
          "confirm_close": "Are you sure you want to close? Unsaved changes will be lost."
        }
      },
      "text_helpers": {
        "join_words_to_sentence": {
          "last_word_connector": " and ",
          "last_word_connector_or": " or ",
          "two_words_connector": " and ",
          "two_words_connector_or": " or ",
          "words_connector": ", "
        }
      },
      "views": {
        "budgets": {
          "card": {
            "actions_count": {
              "one": "%{count} action",
              "other": "%{count} actions"
            },
            "actual_expense": "Actual expense",
            "available_amount": "Available",
            "deviation_percentage": "%{sign}%{value} %",
            "deviation_tooltip_over": "Actual expense is %{amount} higher than planned expense",
            "deviation_tooltip_under": "Actual expense is %{amount} lower than planned expense",
            "draft_warning": "The budget includes actions with draft status, and their expense isn't included.",
            "draft_warning_show_actions_label": "Show actions with draft status",
            "forecast": "Forecast",
            "forecast_tooltip": "Sum of actual expense and remaining planned expense",
            "menu": {
              "delete": "Delete budget",
              "edit": "Edit"
            },
            "missing_final_cost_warning": "The budget includes completed actions without an actual expense.",
            "missing_final_cost_warning_show_actions_label": "Show completed actions without actual expense",
            "overage_amount": "Overrun",
            "planned_expense": "Planned expense",
            "progress_bar_label": "Budget usage: %{consumed} of %{cap}",
            "remaining_planned_expense": "Remaining planned expense",
            "show_actions": "Show actions",
            "spending_cap_excluding_vat": "Budgeted (excl. VAT)",
            "spending_cap_including_vat": "Budgeted (incl. VAT)"
          },
          "delete_dialog": {
            "cancel": "No, cancel",
            "confirm": "Yes, delete",
            "confirmation": {
              "one": " contains one action. The action won't be deleted, but the budget will be unlinked from it.",
              "other": " contains %{count} actions. The actions won't be deleted, but the budget will be unlinked from them.",
              "zero": " contains no actions."
            },
            "title": "Are you sure?"
          },
          "empty_state": {
            "text": "There are no budgets for %{year} yet"
          },
          "export_menu": {
            "excel": "Export Excel",
            "excel_exporting": "Exporting...",
            "excel_failed": "Could not start the export",
            "pdf": "Export PDF",
            "pdf_exporting": "Exporting...",
            "pdf_failed": "Could not start the export"
          },
          "form": {
            "amount": {
              "help_text": {
                "remaining": "Remaining planned expense for %{year}: %{amount} (%{vat_context})",
                "total": "Planned expense for %{year}: %{amount} (%{vat_context})"
              }
            },
            "cancel": "Cancel",
            "display_name_preview": "Shown as: %{display_name}",
            "edit_title": "Edit budget",
            "new_title": "Create budget",
            "save": "Create budget",
            "save_changes": "Update budget",
            "vat_context": {
              "excluding": "excl. VAT",
              "including": "incl. VAT"
            },
            "year_label": "Budget year"
          },
          "heading": "Budget",
          "new_budget_button": "New budget",
          "panel": {
            "actions_guide": {
              "heading": "How to link actions to the budget",
              "step_1": "Click \"Add actions\" below to open Coordination, filtered to actions without a budget for this budget year",
              "step_2": "Filter down to the actions you want to include — e.g. by facility, category or year",
              "step_3": "Select the actions. Use \"Select all\" in the filter bar to quickly select everything filtered",
              "step_4": "Click \"Add to budget\" in the toolbar at the bottom and choose this budget",
              "tip": "Tip - you can also add individual actions via the (…) menu directly on the action"
            },
            "add_actions_button": "Add actions",
            "breakdown": {
              "category_title": "Expense per category",
              "empty_state": "There is no expense to break down yet",
              "expense_type_title": "Expense per expense type",
              "facility_title": "Expense per facility",
              "status_title": "Expense per status"
            },
            "export_button": "Export",
            "view_actions_button": "See actions"
          },
          "total_budget": "Total budget: %{amount}",
          "unbudgeted_actions_warning": {
            "show_actions_label": "Show actions without a budget",
            "text": {
              "one": "%{count} action with a planned expense of %{amount} is scheduled for the year but has no budget.",
              "other": "%{count} actions with a planned expense of %{amount} are scheduled for the year but have no budget."
            }
          },
          "year_navigation": {
            "next_year": "Next year",
            "previous_year": "Previous year"
          }
        },
        "complete_actions": {
          "edit": {
            "confirm_unlock": "Are you sure you want to unlock the action?",
            "save": "Save action",
            "unlock": "Unlock",
            "unlock_explainer": "You are editing a completed action. If the action was completed by mistake, you can unlock it, but note that the action will then lose its connection to upcoming repetitions and its repetition interval.",
            "unsaved_changes_leave_confirm": "Your changes haven't been saved. If you leave this page now, you'll lose what you changed.",
            "year_locked_by_budget": "The action belongs to the budget %{budget} and can't change year"
          }
        },
        "grouped_list": {
          "action_count": {
            "one": "(1 action)",
            "other": "(%{count} actions)"
          },
          "actions_before_plan_start": {
            "one": "There is one action that is not completed and has a planned year before the start of the plan.",
            "other": "There are %{count} actions that are not completed and have a planned year before the start of the plan."
          },
          "actions_before_plan_start_change_filter": "You can %{link}.",
          "actions_before_plan_start_link": "change the filter to show and reschedule these actions",
          "actions_table": {
            "expense_distribution_tooltip": {
              "investment": "Investment, %{pct}%",
              "maintenance": "Maintenance, %{pct}%"
            },
            "headers": {
              "action": "Action",
              "actual_expense": "Actual expense",
              "budget": "Budget",
              "building": "Building",
              "category": "Category",
              "component": "Component",
              "excl_vat": "(excl. VAT)",
              "expense_distribution": "Expense distribution",
              "facility": "Property",
              "incl_vat": "(incl. VAT)",
              "interval": "Interval",
              "location": "Location",
              "organization": "Organization",
              "planned_expense": "Planned expense",
              "previous_year": "Prev. year",
              "project": "Project",
              "quantity": "Quantity",
              "status": "Status",
              "tags": "Tags",
              "total_emission": "Total emission",
              "unit_price": "Unit price",
              "year": "Year"
            },
            "icon_tooltips": {
              "attachments": "Attached files",
              "comments": "%{count} comments",
              "energy_saving": "Energy saving",
              "over_budget": "The budget is exceeded",
              "project": "Connected to a project",
              "suggestion": "Connected to action suggestion"
            },
            "interval_years": "%{count} years",
            "investment": "Investment",
            "maintenance": "Maintenance",
            "menu": {
              "add_to_budget": "Add to budget",
              "add_to_project": "Add to project",
              "column_header": "Action menu",
              "complete": "Complete action",
              "copy": "Copy",
              "delete": "Delete",
              "delete_confirmation": "Are you sure you want to delete this action?",
              "edit": "Edit",
              "edit_project": "Edit project",
              "open_in_new_tab": "Open in new tab",
              "save": "Save",
              "show": "Show"
            },
            "preliminary_emission": "Preliminary",
            "preliminary_price": "Preliminary",
            "price_tooltip": {
              "admin_rate": "Client costs",
              "amount": "Amount",
              "indexation_rate": "Indexation",
              "unit_price": "Unit price",
              "vat_rate": "VAT rate"
            },
            "select_action": "Select action",
            "select_all_actions": "Select all actions",
            "status_change_failed": "The status couldn't be updated. Try again."
          },
          "budget_assignment_dialog": {
            "all_already_in_budget": {
              "one": "The action already belongs to this budget",
              "other": "All %{count} actions already belong to this budget"
            },
            "already_in_budget": "%{count} of %{total} actions already belong to this budget",
            "assignment_mode_label": "How should the actions be added?",
            "available_amount": "Available",
            "budget_placeholder": "Select a budget",
            "cancel": "Cancel",
            "conflicts": {
              "one": "%{count} action already belongs to another budget",
              "other": "%{count} actions already belong to another budget"
            },
            "draft_notice": "%{count} of the actions are drafts. Their expense isn't included in the budget until the status changes.",
            "error_general": "Something went wrong. Try again.",
            "existing_budget_option": "Add to existing budget",
            "move_conflicting": "Move these from another budget",
            "new_budget_option": "Create budget",
            "new_budget_planned_expense_help": "Planned expense for the selected actions: %{amount} %{vat_suffix}",
            "no_budget_for_year_notice": "There is no budget for %{year}. Ask an administrator to create a budget for the year.",
            "overage_amount": "Exceeded by %{amount}",
            "overspend_warning": "The budget cap will be exceeded by %{amount}",
            "pending_amount": "The budget will increase by %{amount} %{vat_suffix}",
            "save": {
              "one": "Add %{count} action to budget",
              "other": "Add %{count} actions to budget"
            },
            "summary": {
              "one": "%{count} action with a planned expense of %{amount} %{vat_suffix}",
              "other": "%{count} actions with a planned expense of %{amount} %{vat_suffix}"
            },
            "switch_title": "Switch budget",
            "title": "Add to budget",
            "vat_suffix": {
              "excluding": "(excl. VAT)",
              "including": "(incl. VAT)"
            }
          },
          "budget_badge": {
            "excl_vat": "(excl. VAT)",
            "incl_vat": "(incl. VAT)",
            "over_budget": "Over budget: %{amount}",
            "remaining": "Remaining in budget: %{amount}"
          },
          "column_menu": {
            "drag_handle_label": "Reorder %{column}"
          },
          "columns_button": "Columns (%{count})",
          "delete_saved_filter_dialog": {
            "body": "Are you sure you want to delete the filter \"%{name}\"?",
            "cancel": "No, cancel",
            "confirm": "Yes, delete",
            "title": "Delete saved filter"
          },
          "filters": {
            "badge_range": "%{from}–%{to}",
            "badge_range_currency": "%{from}–%{to} kr",
            "budget": {
              "label": "Budget"
            },
            "building": {
              "label": "Building"
            },
            "category_name": {
              "label": "Category"
            },
            "clear_button": "Clear filters",
            "close_button": "Close filters",
            "connected_to_suggestion": {
              "label": "Connected to Planima price"
            },
            "dismiss_filter": "Remove %{label}",
            "empty": "No actions were found",
            "facility_component": {
              "label": "Component"
            },
            "investment_rate": {
              "label": "Expense type"
            },
            "is_energy_saving": {
              "label": "Energy saving"
            },
            "location": {
              "label": "Location"
            },
            "maintenance_plan_selection_list": {
              "label": "Maintenance plan"
            },
            "more_badges": "... and %{count} more",
            "plan_selection_list": {
              "label": "Property/Organisation"
            },
            "project": {
              "label": "Project"
            },
            "range_invalid": "The value is too low",
            "save_filter_button": "Save filter",
            "saved_filters_button": "Saved filters",
            "status": {
              "label": "Status"
            },
            "tag_ids": {
              "label": "Tags"
            },
            "title": "Filters",
            "total_price": {
              "field_label": "Planned expense (from - to)",
              "from_placeholder": "From (kr)",
              "label": "Planned expense",
              "to_placeholder": "To (kr)"
            },
            "vat_rate": {
              "label": "VAT rate"
            },
            "year": {
              "field_label": "Year (from - to)",
              "from_placeholder": "From",
              "label": "Year",
              "to_placeholder": "To"
            },
            "year_badge": "Year: %{from}–%{to}",
            "year_from_placeholder": "From",
            "year_label": "Year (from - to)",
            "year_to_placeholder": "To"
          },
          "floating_bar": {
            "add_to_budget": "Add to budget",
            "add_to_budget_disabled_tooltip": {
              "mixed_years": "The selected actions have different planned years.",
              "no_budget_for_year": "There is no budget for %{year}",
              "too_many_actions": "You cannot add more than 1000 actions to a budget at the same time."
            },
            "close": "Close",
            "copy": "Copy",
            "delete": "Delete",
            "edit": "Edit",
            "mass_copy_disabled_tooltip": "You cannot copy more than 1000 actions at the same time.",
            "mass_delete_disabled_tooltip": "You cannot delete more than 1000 actions at the same time.",
            "mass_edit_disabled_tooltip": "You cannot edit more than 1000 actions at the same time.",
            "select_all": "Select all",
            "selected": {
              "one": "1 selected action",
              "other": "%{count} selected actions"
            }
          },
          "generate_actions": "Generate actions",
          "group_actions_failed": "The actions in this group could not be loaded",
          "group_costs": {
            "actual": "Actual:",
            "planned": "Planned:"
          },
          "grouping": {
            "main_group": "Main group",
            "options": {
              "action": "Action",
              "budget": "Budget",
              "building": "Building",
              "category": "Category",
              "component": "Component",
              "facility": "Property",
              "location": "Location",
              "none": "No group",
              "project": "Project",
              "year": "Year"
            },
            "sub_group": "Subgroup"
          },
          "groups_collapse_mode": {
            "collapsed": "Collapsed groups",
            "expanded": "Expanded groups",
            "label": "Group display mode"
          },
          "include_vat": "Include VAT",
          "loading": "Loading actions...",
          "new_action": "New action",
          "new_action_in_group": "New action in %{group}",
          "project_dialog": {
            "label": "Project",
            "placeholder": "Choose project"
          },
          "recalculating_plans": "Planima is working on calculating your maintenance, which may take a minute. No further changes can be made during this time.",
          "recalculating_tooltip": "You can't make changes while Planima is calculating your maintenance",
          "retry": "Try again",
          "save_filter_modal": {
            "name_empty": "Name is required",
            "name_label": "Name",
            "name_placeholder": "Enter a filter name",
            "name_taken": "You already have a filter named “%{existingName}”",
            "name_too_long": "Name can be at most %{count} characters",
            "save": "Save",
            "title": "Save filter"
          },
          "saved_filters_dropdown": {
            "delete_aria_label": "Delete %{name}",
            "empty": "No saved filters"
          },
          "search": {
            "clear": "Clear search",
            "empty": "No actions match your search",
            "placeholder": "Search action or tag"
          },
          "settings": "Settings",
          "show_more_actions": "Show more (%{count} left)",
          "show_more_groups": "Show more groups (%{count} left)",
          "show_more_groups_failed": "More groups could not be loaded",
          "show_more_subgroups": "Show more subgroups (%{count} left)",
          "show_repetitions": "Show repetitions",
          "subgroups_failed": "The subgroups could not be loaded",
          "title": "Coordination"
        },
        "maintenance_plan_actions": {
          "edit_title": "Edit action",
          "form": {
            "action_checkindex": {
              "label": "Indexation?"
            },
            "action_name": {
              "label": "Action name",
              "modal_trigger": "Choose from action suggestions",
              "tooltip": "Describe what should be done and on which part of the property. Example: 'Paint facade panel'"
            },
            "action_suggestion": {
              "no_results": "Your search yielded no results",
              "prompt": "Start typing to get suggestions for actions!",
              "prompt_tip_html": "Tip! Search for <em>what you are performing the action on</em> (e.g. \"fence\") instead of <em>what activity is to be performed</em> (e.g. \"paint\").",
              "show_all_results_html": "Show all results for \"%{query}\" (%{result_count})",
              "show_all_suggestions": "Show all action suggestions",
              "table_heads": {
                "emission": "Emission",
                "name": "Name",
                "repeated": "Interval",
                "unit": "Unit",
                "unit_price": "Unit price"
              },
              "trial_account_info": "In trial accounts, only a selection of our Planima prices is displayed. As a customer, you get access to all 1300 Planima prices!"
            },
            "amount": {
              "choose_from_amounts": "Choose from quantity list",
              "label": "Amount",
              "match": "Amount from:",
              "mismatch": "Amount differs from:",
              "no_amount": "lacks amount",
              "tooltip": "The number of the specified unit the action should be performed on. Example: If 20 m2 of facade panel is to be painted, enter 20."
            },
            "budget": {
              "choose_year_first": "Enter the planned year first",
              "label": "Budget",
              "no_budgets_for_year": "There are no budgets for the selected year",
              "placeholder": "Choose budget",
              "tooltip": "Links the action to one of the budgets for the planned year"
            },
            "building_name": {
              "label": "Building",
              "placeholder": "Choose building",
              "tooltip": "The building where the action is to be performed, if the property consists of several buildings. Leave blank if it should be performed on all buildings! Example: '123 Main Street'"
            },
            "carbon_dioxide_equivalent": {
              "label": "Emissions per unit",
              "tooltip": "Enter kg CO₂ equivalents per unit."
            },
            "category": {
              "label": "Category",
              "not_matching_component_category": "Category differs from the selected component's category: %{component_category}",
              "placeholder": "Choose category",
              "tooltip": "Category to which the action should belong, used to filter and group actions."
            },
            "comments": {
              "delete_confirmation": "Are you sure you want to remove the comment? The comment will be permanently removed and cannot be restored.",
              "delete_error": "The comment couldn't be deleted. Please try again.",
              "empty": "No comments yet",
              "load_error": "Comments couldn't be loaded. Please try again.",
              "load_more": "Show more comments",
              "mention_hint": "Type @ to mention someone",
              "new_comment_label": "Comment",
              "placeholder": "Write a comment…",
              "send": "Send",
              "send_error": "The comment couldn't be sent. Please try again."
            },
            "component": {
              "clear": "Clear component selection",
              "component_is_created_on_save": "The component will be created on the building when you save",
              "group_other": "Other components",
              "group_suggested": "Suggested components",
              "label": "Component",
              "no_suggestions": "No component suggestions found",
              "placeholder": "Choose component",
              "show_all_suggestions": "Show all component suggestions",
              "tooltip": "The component is a specific part of the property where the action is to be performed. If the component belongs to a specific building, it must be the same as the building of the action."
            },
            "component_suggestion": {
              "on_building": {
                "no": "No",
                "yes": "Yes"
              },
              "table_heads": {
                "amount": "Amount",
                "name": "Name",
                "on_building": "Exists on selected building",
                "unit": "Unit"
              },
              "title": "Component suggestions",
              "unspecified_building": "Unspecified building"
            },
            "create_previously_completed": {
              "label": "Create completed action"
            },
            "description": {
              "label": "Description",
              "tooltip": "Additional information about the action."
            },
            "follow_suggestion": {
              "label": "Follow action suggestion"
            },
            "headings": {
              "attachments": "Attachments",
              "category_and_grouping": "Categorization & grouping",
              "comments": "Comments",
              "energy_and_sustainability": "Energy & sustainability",
              "misc": "Miscellaneous"
            },
            "indexation_starts_on_year": {
              "label": "Indexation base year"
            },
            "investment_rate_selector": {
              "distribute_rate": "Distribute expense",
              "investment": "Investment",
              "investment_rate": "Investment share",
              "label": "Expense type",
              "maintenance": "Maintenance",
              "maintenance_rate": "Maintenance share",
              "tooltip": "Indicates whether it is a maintenance action or an investment. The latter is not included in the maintenance debt, for example."
            },
            "is_energy_saving": {
              "description": "The economic savings are calculated based on the property's energy prices. Update electricity and heating prices on the <a href=\"%{facility_about_path}\">About the property</a> page. Energy savings are displayed for the selected interval, or just for the planned year if no interval is specified.",
              "description_no_link": "The economic savings are calculated based on the property's energy prices. Energy savings are displayed for the selected interval, or just for the planned year if no interval is specified.",
              "label": "Energy saving?"
            },
            "location": {
              "label": "Location",
              "placeholder": "Choose location",
              "tooltip": "Location indicates a place in the property. Example: 'Stairwell' or 'Laundry room'."
            },
            "maintenance_plan": {
              "choose_maintenance_plan_first": "Choose maintenance plan first",
              "label": "Maintenance plan",
              "placeholder": "Choose maintenance plan"
            },
            "previous_year": {
              "label": "Last completed/built"
            },
            "project": {
              "label": "Project",
              "placeholder": "Choose project",
              "tooltip": "Link the action to a project to group actions to be performed together."
            },
            "repeated": {
              "label": "Interval",
              "tooltip": "Number of years between repetitions of the action. Example: An action planned for 2022 with an interval of 10 years will also be planned for 2032, 2042, etc."
            },
            "status": {
              "label": "Status",
              "placeholder": "Choose status",
              "tooltip": "Status of the action, used to filter and group actions, and to calculate maintenance debt."
            },
            "submit": {
              "cancel": "Cancel",
              "delete": "Delete action",
              "delete_confirmation": "Are you sure you want to delete the action?",
              "save_and_add_more": "Save and add new action",
              "save_as_draft": "Save as draft",
              "submit": "Save action"
            },
            "suggestion": {
              "info_title": "What is included in the Planima price?"
            },
            "tags": {
              "label": "Tags",
              "placeholder": "Type and select tag from the list",
              "tooltip": "Enter one or more optional tags, which can be used to filter actions. Example: project number, action code, responsible person"
            },
            "total_calculations": {
              "annual_savings": "Annual savings:",
              "payback_time": "Payback time:",
              "total_cost": "Total price:",
              "total_cost_admin_rate": "client cost (%{admin_rate}%)",
              "total_cost_excl_vat": "excl. VAT",
              "total_cost_incl_prefix": "incl. ",
              "total_cost_incl_vat": "incl. VAT (%{vat_rate}%)",
              "total_cost_indexation_rate": "indexation (%{indexation_rate}%)",
              "total_emissions": "Total emissions:"
            },
            "unit": {
              "label": "Unit",
              "mismatch": "Unit differs from the selected component (%{unit})",
              "tooltip": "The unit for the quantity to be performed. Example: The price for painting facade panel depends on the number of square meters, so enter 'm2'"
            },
            "unit_price": {
              "label": "Unit price (excl. VAT)",
              "too_high_amount": "The price for this action is unusually high. Check that the amount and unit price are reasonable.",
              "tooltip": "Price per unit to perform the action, including both material and labor costs. Example: Price per square meter for painting facade panel"
            },
            "vat_rate": {
              "custom_input_label": "Custom VAT rate",
              "label": "VAT rate",
              "other": "Other…",
              "placeholder": "Choose VAT rate",
              "tooltip": "The VAT rate for this specific action. It won't change if the plan's default VAT rate is updated later."
            },
            "year": {
              "label": "Planned year",
              "recommendation": "Based on the interval, the planned year should be"
            },
            "yearly_electricity_savings_kwh": {
              "label": "Total electricity savings per year",
              "tooltip": "Savings in electricity consumption for the entire action"
            },
            "yearly_heating_savings_kwh": {
              "label": "Total heating savings per year",
              "tooltip": "Savings in heating consumption for the entire action"
            }
          },
          "new_title": "Create new action",
          "page_unsaved_changes_confirm": "Your changes haven't been saved. If you leave the page now, you'll lose what you changed.",
          "show": {
            "amount_and_unit": "Amount / Unit",
            "annual_energy_savings_kwh": "Annual energy savings (kWh)",
            "annual_energy_savings_sek": "Annual energy savings (SEK)",
            "building": "Building",
            "carbon_dioxide_equivalent_total": "Total emissions",
            "completed": "Completed",
            "component": "Component",
            "electricity_savings_distribution": "Electricity savings distribution",
            "energy_saving_no": "No",
            "energy_saving_yes": "Yes",
            "facility": "Facility",
            "final_cost_excl_vat": "Actual price (excl. VAT)",
            "final_cost_incl_vat": "Actual price (incl. VAT %{vat_percentage}%)",
            "heat_savings_distribution": "Heat savings distribution",
            "maintenance_plan": "Maintenance plan",
            "no_files": "No files attached",
            "payback_time": "Payback time",
            "payback_time_tooltip": "Based on total price and annual energy savings",
            "planned": "Planned",
            "planned_and_repeated": {
              "every_other_year": "%{planned_year}, then every other year.",
              "every_year": "%{planned_year}, then every year.",
              "interval": "%{planned_year}, then every %{interval} years.",
              "once": "%{planned_year}"
            },
            "previously_repeated": "Previously completed",
            "price_breakdown": {
              "administration_cost_percentage": "Construction management costs",
              "amount": "Amount",
              "indexation": "Indexation",
              "unit_price": "Unit price",
              "vat_rate": "VAT rate"
            },
            "price_breakdown_label": "Show price breakdown",
            "total_price_excl_vat": "Total price (excl. VAT)",
            "total_price_incl_vat": "Total price (incl. VAT)",
            "unit_price_excl_vat": "Unit price (excl. VAT)"
          }
        }
      }
    }
  }
}